import { format, toZonedTime } from 'date-fns-tz';

export const formatEventTime = (startUtc: string, timezone: string): string => {
  const startDate = toZonedTime(new Date(startUtc), timezone);

  return format(startDate, 'EEE, dd MMM yyyy h:mm a', {
    timeZone: timezone,
  });
};
